module.exports = __webpack_public_path__ + "static/img/ojk-page.980bf304.jpg";